export const countryCode = [
    {"id": "38", "NAME": "Canada", "symbol": "CA / CAN", "code": "1"},
    {"id": "229", "NAME": "United States", "symbol": "US / USA", "code": "1"},
    {"id": "16", "NAME": "Bahamas", "symbol": "BS / BHS", "code": "1-242"},
    {"id": "19", "NAME": "Barbados", "symbol": "BB / BRB", "code": "1-246"},
    {"id": "7", "NAME": "Anguilla", "symbol": "AI / AIA", "code": "1-264"},
    {"id": "9", "NAME": "Antigua and Barbuda", "symbol": "AG / ATG", "code": "1-268"},
    {"id": "31", "NAME": "British Virgin Islands", "symbol": "VG / VGB", "code": "1-284"},
    {"id": "224", "NAME": "U.S. Virgin Islands", "symbol": "VI / VIR", "code": "1-340"},
    {"id": "40", "NAME": "Cayman Islands", "symbol": "KY / CYM", "code": "1-345"},
    {"id": "24", "NAME": "Bermuda", "symbol": "BM / BMU", "code": "1-441"},
    {"id": "83", "NAME": "Grenada", "symbol": "GD / GRD", "code": "1-473"},
    {"id": "222", "NAME": "Turks and Caicos Islands", "symbol": "TC / TCA", "code": "1-649"},
    {"id": "141", "NAME": "Montserrat", "symbol": "MS / MSR", "code": "1-664"},
    {"id": "157", "NAME": "Northern Mariana Islands", "symbol": "MP / MNP", "code": "1-670"},
    {"id": "84", "NAME": "Guam", "symbol": "GU / GUM", "code": "1-671"},
    {"id": "4", "NAME": "American Samoa", "symbol": "AS / ASM", "code": "1-684"},
    {"id": "194", "NAME": "Sint Maarten", "symbol": "SX / SXM", "code": "1-721"},
    {"id": "181", "NAME": "Saint Lucia", "symbol": "LC / LCA", "code": "1-758"},
    {"id": "59", "NAME": "Dominica", "symbol": "DM / DMA", "code": "1-767"},
    {"id": "184", "NAME": "Saint Vincent and the Grenadines", "symbol": "VC / VCT", "code": "1-784"},
    {"id": "171", "NAME": "Puerto Rico", "symbol": "PR / PRI", "code": "1-787, 1-9"},
    {"id": "60", "NAME": "Dominican Republic", "symbol": "DO / DOM", "code": "1-809, 1-8"},
    {"id": "218", "NAME": "Trinidad and Tobago", "symbol": "TT / TTO", "code": "1-868"},
    {"id": "180", "NAME": "Saint Kitts and Nevis", "symbol": "KN / KNA", "code": "1-869"},
    {"id": "104", "NAME": "Jamaica", "symbol": "JM / JAM", "code": "1-876"},
    {"id": "63", "NAME": "Egypt", "symbol": "EG / EGY", "code": "20"},
    {"id": "201", "NAME": "South Sudan", "symbol": "SS / SSD", "code": "211"},
    {"id": "142", "NAME": "Morocco", "symbol": "MA / MAR", "code": "212"},
    {"id": "237", "NAME": "Western Sahara", "symbol": "EH / ESH", "code": "212"},
    {"id": "3", "NAME": "Algeria", "symbol": "DZ / DZA", "code": "213"},
    {"id": "219", "NAME": "Tunisia", "symbol": "TN / TUN", "code": "216"},
    {"id": "119", "NAME": "Libya", "symbol": "LY / LBY", "code": "218"},
    {"id": "76", "NAME": "Gambia", "symbol": "GM / GMB", "code": "220"},
    {"id": "189", "NAME": "Senegal", "symbol": "SN / SEN", "code": "221"},
    {"id": "132", "NAME": "Mauritania", "symbol": "MR / MRT", "code": "222"},
    {"id": "129", "NAME": "Mali", "symbol": "ML / MLI", "code": "223"},
    {"id": "87", "NAME": "Guinea", "symbol": "GN / GIN", "code": "224"},
    {"id": "103", "NAME": "Ivory Coast", "symbol": "CI / CIV", "code": "225"},
    {"id": "34", "NAME": "Burkina Faso", "symbol": "BF / BFA", "code": "226"},
    {"id": "153", "NAME": "Niger", "symbol": "NE / NER", "code": "227"},
    {"id": "215", "NAME": "Togo", "symbol": "TG / TGO", "code": "228"},
    {"id": "23", "NAME": "Benin", "symbol": "BJ / BEN", "code": "229"},
    {"id": "133", "NAME": "Mauritius", "symbol": "MU / MUS", "code": "230"},
    {"id": "118", "NAME": "Liberia", "symbol": "LR / LBR", "code": "231"},
    {"id": "192", "NAME": "Sierra Leone", "symbol": "SL / SLE", "code": "232"},
    {"id": "79", "NAME": "Ghana", "symbol": "GH / GHA", "code": "233"},
    {"id": "154", "NAME": "Nigeria", "symbol": "NG / NGA", "code": "234"},
    {"id": "42", "NAME": "Chad", "symbol": "TD / TCD", "code": "235"},
    {"id": "41", "NAME": "Central African Republic", "symbol": "CF / CAF", "code": "236"},
    {"id": "37", "NAME": "Cameroon", "symbol": "CM / CMR", "code": "237"},
    {"id": "39", "NAME": "Cape Verde", "symbol": "CV / CPV", "code": "238"},
    {"id": "187", "NAME": "Sao Tome and Principe", "symbol": "ST / STP", "code": "239"},
    {"id": "65", "NAME": "Equatorial Guinea", "symbol": "GQ / GNQ", "code": "240"},
    {"id": "75", "NAME": "Gabon", "symbol": "GA / GAB", "code": "241"},
    {"id": "173", "NAME": "Republic of the Congo", "symbol": "CG / COG", "code": "242"},
    {"id": "56", "NAME": "Democratic Republic of the Congo", "symbol": "CD / COD", "code": "243"},
    {"id": "6", "NAME": "Angola", "symbol": "AO / AGO", "code": "244"},
    {"id": "88", "NAME": "Guinea-Bissau", "symbol": "GW / GNB", "code": "245"},
    {"id": "30", "NAME": "British Indian Ocean Territory", "symbol": "IO / IOT", "code": "246"},
    {"id": "191", "NAME": "Seychelles", "symbol": "SC / SYC", "code": "248"},
    {"id": "204", "NAME": "Sudan", "symbol": "SD / SDN", "code": "249"},
    {"id": "177", "NAME": "Rwanda", "symbol": "RW / RWA", "code": "250"},
    {"id": "68", "NAME": "Ethiopia", "symbol": "ET / ETH", "code": "251"},
    {"id": "198", "NAME": "Somalia", "symbol": "SO / SOM", "code": "252"},
    {"id": "58", "NAME": "Djibouti", "symbol": "DJ / DJI", "code": "253"},
    {"id": "109", "NAME": "Kenya", "symbol": "KE / KEN", "code": "254"},
    {"id": "213", "NAME": "Tanzania", "symbol": "TZ / TZA", "code": "255"},
    {"id": "225", "NAME": "Uganda", "symbol": "UG / UGA", "code": "256"},
    {"id": "35", "NAME": "Burundi", "symbol": "BI / BDI", "code": "257"},
    {"id": "143", "NAME": "Mozambique", "symbol": "MZ / MOZ", "code": "258"},
    {"id": "239", "NAME": "Zambia", "symbol": "ZM / ZMB", "code": "260"},
    {"id": "125", "NAME": "Madagascar", "symbol": "MG / MDG", "code": "261"},
    {"id": "134", "NAME": "Mayotte", "symbol": "YT / MYT", "code": "262"},
    {"id": "174", "NAME": "Reunion", "symbol": "RE / REU", "code": "262"},
    {"id": "240", "NAME": "Zimbabwe", "symbol": "ZW / ZWE", "code": "263"},
    {"id": "145", "NAME": "Namibia", "symbol": "NA / NAM", "code": "264"},
    {"id": "126", "NAME": "Malawi", "symbol": "MW / MWI", "code": "265"},
    {"id": "117", "NAME": "Lesotho", "symbol": "LS / LSO", "code": "266"},
    {"id": "28", "NAME": "Botswana", "symbol": "BW / BWA", "code": "267"},
    {"id": "207", "NAME": "Swaziland", "symbol": "SZ / SWZ", "code": "268"},
    {"id": "48", "NAME": "Comoros", "symbol": "KM / COM", "code": "269"},
    {"id": "199", "NAME": "South Africa", "symbol": "ZA / ZAF", "code": "27"},
    {"id": "179", "NAME": "Saint Helena", "symbol": "SH / SHN", "code": "290"},
    {"id": "66", "NAME": "Eritrea", "symbol": "ER / ERI", "code": "291"},
    {"id": "12", "NAME": "Aruba", "symbol": "AW / ABW", "code": "297"},
    {"id": "70", "NAME": "Faroe Islands", "symbol": "FO / FRO", "code": "298"},
    {"id": "82", "NAME": "Greenland", "symbol": "GL / GRL", "code": "299"},
    {"id": "81", "NAME": "Greece", "symbol": "GR / GRC", "code": "30"},
    {"id": "148", "NAME": "Netherlands", "symbol": "NL / NLD", "code": "31"},
    {"id": "21", "NAME": "Belgium", "symbol": "BE / BEL", "code": "32"},
    {"id": "73", "NAME": "France", "symbol": "FR / FRA", "code": "33"},
    {"id": "202", "NAME": "Spain", "symbol": "ES / ESP", "code": "34"},
    {"id": "80", "NAME": "Gibraltar", "symbol": "GI / GIB", "code": "350"},
    {"id": "170", "NAME": "Portugal", "symbol": "PT / PRT", "code": "351"},
    {"id": "122", "NAME": "Luxembourg", "symbol": "LU / LUX", "code": "352"},
    {"id": "99", "NAME": "Ireland", "symbol": "IE / IRL", "code": "353"},
    {"id": "94", "NAME": "Iceland", "symbol": "IS / ISL", "code": "354"},
    {"id": "2", "NAME": "Albania", "symbol": "AL / ALB", "code": "355"},
    {"id": "130", "NAME": "Malta", "symbol": "MT / MLT", "code": "356"},
    {"id": "54", "NAME": "Cyprus", "symbol": "CY / CYP", "code": "357"},
    {"id": "72", "NAME": "Finland", "symbol": "FI / FIN", "code": "358"},
    {"id": "33", "NAME": "Bulgaria", "symbol": "BG / BGR", "code": "359"},
    {"id": "93", "NAME": "Hungary", "symbol": "HU / HUN", "code": "36"},
    {"id": "121", "NAME": "Lithuania", "symbol": "LT / LTU", "code": "370"},
    {"id": "115", "NAME": "Latvia", "symbol": "LV / LVA", "code": "371"},
    {"id": "67", "NAME": "Estonia", "symbol": "EE / EST", "code": "372"},
    {"id": "137", "NAME": "Moldova", "symbol": "MD / MDA", "code": "373"},
    {"id": "11", "NAME": "Armenia", "symbol": "AM / ARM", "code": "374"},
    {"id": "20", "NAME": "Belarus", "symbol": "BY / BLR", "code": "375"},
    {"id": "5", "NAME": "Andorra", "symbol": "AD / AND", "code": "376"},
    {"id": "138", "NAME": "Monaco", "symbol": "MC / MCO", "code": "377"},
    {"id": "186", "NAME": "San Marino", "symbol": "SM / SMR", "code": "378"},
    {"id": "233", "NAME": "Vatican", "symbol": "VA / VAT", "code": "379"},
    {"id": "226", "NAME": "Ukraine", "symbol": "UA / UKR", "code": "380"},
    {"id": "190", "NAME": "Serbia", "symbol": "RS / SRB", "code": "381"},
    {"id": "140", "NAME": "Montenegro", "symbol": "ME / MNE", "code": "382"},
    {"id": "111", "NAME": "Kosovo", "symbol": "XK / XKX", "code": "383"},
    {"id": "51", "NAME": "Croatia", "symbol": "HR / HRV", "code": "385"},
    {"id": "196", "NAME": "Slovenia", "symbol": "SI / SVN", "code": "386"},
    {"id": "27", "NAME": "Bosnia and Herzegovina", "symbol": "BA / BIH", "code": "387"},
    {"id": "124", "NAME": "Macedonia", "symbol": "MK / MKD", "code": "389"},
    {"id": "102", "NAME": "Italy", "symbol": "IT / ITA", "code": "39"},
    {"id": "175", "NAME": "Romania", "symbol": "RO / ROU", "code": "40"},
    {"id": "209", "NAME": "Switzerland", "symbol": "CH / CHE", "code": "41"},
    {"id": "55", "NAME": "Czech Republic", "symbol": "CZ / CZE", "code": "420"},
    {"id": "195", "NAME": "Slovakia", "symbol": "SK / SVK", "code": "421"},
    {"id": "120", "NAME": "Liechtenstein", "symbol": "LI / LIE", "code": "423"},
    {"id": "14", "NAME": "Austria", "symbol": "AT / AUT", "code": "43"},
    {"id": "228", "NAME": "United Kingdom", "symbol": "GB / GBR", "code": "44"},
    {"id": "86", "NAME": "Guernsey", "symbol": "GG / GGY", "code": "44-1481"},
    {"id": "106", "NAME": "Jersey", "symbol": "JE / JEY", "code": "44-1534"},
    {"id": "100", "NAME": "Isle of Man", "symbol": "IM / IMN", "code": "44-1624"},
    {"id": "57", "NAME": "Denmark", "symbol": "DK / DNK", "code": "45"},
    {"id": "208", "NAME": "Sweden", "symbol": "SE / SWE", "code": "46"},
    {"id": "158", "NAME": "Norway", "symbol": "NO / NOR", "code": "47"},
    {"id": "206", "NAME": "Svalbard and Jan Mayen", "symbol": "SJ / SJM", "code": "47"},
    {"id": "169", "NAME": "Poland", "symbol": "PL / POL", "code": "48"},
    {"id": "78", "NAME": "Germany", "symbol": "DE / DEU", "code": "49"},
    {"id": "69", "NAME": "Falkland Islands", "symbol": "FK / FLK", "code": "500"},
    {"id": "22", "NAME": "Belize", "symbol": "BZ / BLZ", "code": "501"},
    {"id": "85", "NAME": "Guatemala", "symbol": "GT / GTM", "code": "502"},
    {"id": "64", "NAME": "El Salvador", "symbol": "SV / SLV", "code": "503"},
    {"id": "91", "NAME": "Honduras", "symbol": "HN / HND", "code": "504"},
    {"id": "152", "NAME": "Nicaragua", "symbol": "NI / NIC", "code": "505"},
    {"id": "50", "NAME": "Costa Rica", "symbol": "CR / CRI", "code": "506"},
    {"id": "163", "NAME": "Panama", "symbol": "PA / PAN", "code": "507"},
    {"id": "183", "NAME": "Saint Pierre and Miquelon", "symbol": "PM / SPM", "code": "508"},
    {"id": "90", "NAME": "Haiti", "symbol": "HT / HTI", "code": "509"},
    {"id": "166", "NAME": "Peru", "symbol": "PE / PER", "code": "51"},
    {"id": "135", "NAME": "Mexico", "symbol": "MX / MEX", "code": "52"},
    {"id": "52", "NAME": "Cuba", "symbol": "CU / CUB", "code": "53"},
    {"id": "10", "NAME": "Argentina", "symbol": "AR / ARG", "code": "54"},
    {"id": "29", "NAME": "Brazil", "symbol": "BR / BRA", "code": "55"},
    {"id": "43", "NAME": "Chile", "symbol": "CL / CHL", "code": "56"},
    {"id": "47", "NAME": "Colombia", "symbol": "CO / COL", "code": "57"},
    {"id": "234", "NAME": "Venezuela", "symbol": "VE / VEN", "code": "58"},
    {"id": "178", "NAME": "Saint Barthelemy", "symbol": "BL / BLM", "code": "590"},
    {"id": "182", "NAME": "Saint Martin", "symbol": "MF / MAF", "code": "590"},
    {"id": "26", "NAME": "Bolivia", "symbol": "BO / BOL", "code": "591"},
    {"id": "89", "NAME": "Guyana", "symbol": "GY / GUY", "code": "592"},
    {"id": "62", "NAME": "Ecuador", "symbol": "EC / ECU", "code": "593"},
    {"id": "165", "NAME": "Paraguay", "symbol": "PY / PRY", "code": "595"},
    {"id": "205", "NAME": "Suriname", "symbol": "SR / SUR", "code": "597"},
    {"id": "230", "NAME": "Uruguay", "symbol": "UY / URY", "code": "598"},
    {"id": "53", "NAME": "Curacao", "symbol": "CW / CUW", "code": "599"},
    {"id": "149", "NAME": "Netherlands Antilles", "symbol": "AN / ANT", "code": "599"},
    {"id": "127", "NAME": "Malaysia", "symbol": "MY / MYS", "code": "60"},
    {"id": "13", "NAME": "Australia", "symbol": "AU / AUS", "code": "61"},
    {"id": "45", "NAME": "Christmas Island", "symbol": "CX / CXR", "code": "61"},
    {"id": "46", "NAME": "Cocos Islands", "symbol": "CC / CCK", "code": "61"},
    {"id": "96", "NAME": "Indonesia", "symbol": "ID / IDN", "code": "62"},
    {"id": "167", "NAME": "Philippines", "symbol": "PH / PHL", "code": "63"},
    {"id": "151", "NAME": "New Zealand", "symbol": "NZ / NZL", "code": "64"},
    {"id": "168", "NAME": "Pitcairn", "symbol": "PN / PCN", "code": "64"},
    {"id": "193", "NAME": "Singapore", "symbol": "SG / SGP", "code": "65"},
    {"id": "214", "NAME": "Thailand", "symbol": "TH / THA", "code": "66"},
    {"id": "61", "NAME": "East Timor", "symbol": "TL / TLS", "code": "670"},
    {"id": "8", "NAME": "Antarctica", "symbol": "AQ / ATA", "code": "672"},
    {"id": "32", "NAME": "Brunei", "symbol": "BN / BRN", "code": "673"},
    {"id": "146", "NAME": "Nauru", "symbol": "NR / NRU", "code": "674"},
    {"id": "164", "NAME": "Papua New Guinea", "symbol": "PG / PNG", "code": "675"},
    {"id": "217", "NAME": "Tonga", "symbol": "TO / TON", "code": "676"},
    {"id": "197", "NAME": "Solomon Islands", "symbol": "SB / SLB", "code": "677"},
    {"id": "232", "NAME": "Vanuatu", "symbol": "VU / VUT", "code": "678"},
    {"id": "71", "NAME": "Fiji", "symbol": "FJ / FJI", "code": "679"},
    {"id": "161", "NAME": "Palau", "symbol": "PW / PLW", "code": "680"},
    {"id": "236", "NAME": "Wallis and Futuna", "symbol": "WF / WLF", "code": "681"},
    {"id": "49", "NAME": "Cook Islands", "symbol": "CK / COK", "code": "682"},
    {"id": "155", "NAME": "Niue", "symbol": "NU / NIU", "code": "683"},
    {"id": "185", "NAME": "Samoa", "symbol": "WS / WSM", "code": "685"},
    {"id": "110", "NAME": "Kiribati", "symbol": "KI / KIR", "code": "686"},
    {"id": "150", "NAME": "New Caledonia", "symbol": "NC / NCL", "code": "687"},
    {"id": "223", "NAME": "Tuvalu", "symbol": "TV / TUV", "code": "688"},
    {"id": "74", "NAME": "French Polynesia", "symbol": "PF / PYF", "code": "689"},
    {"id": "216", "NAME": "Tokelau", "symbol": "TK / TKL", "code": "690"},
    {"id": "136", "NAME": "Micronesia", "symbol": "FM / FSM", "code": "691"},
    {"id": "131", "NAME": "Marshall Islands", "symbol": "MH / MHL", "code": "692"},
    {"id": "108", "NAME": "Kazakhstan", "symbol": "KZ / KAZ", "code": "7"},
    {"id": "176", "NAME": "Russia", "symbol": "RU / RUS", "code": "7"},
    {"id": "105", "NAME": "Japan", "symbol": "JP / JPN", "code": "81"},
    {"id": "200", "NAME": "South Korea", "symbol": "KR / KOR", "code": "82"},
    {"id": "235", "NAME": "Vietnam", "symbol": "VN / VNM", "code": "84"},
    {"id": "156", "NAME": "North Korea", "symbol": "KP / PRK", "code": "850"},
    {"id": "92", "NAME": "Hong Kong", "symbol": "HK / HKG", "code": "852"},
    {"id": "123", "NAME": "Macau", "symbol": "MO / MAC", "code": "853"},
    {"id": "36", "NAME": "Cambodia", "symbol": "KH / KHM", "code": "855"},
    {"id": "114", "NAME": "Laos", "symbol": "LA / LAO", "code": "856"},
    {"id": "44", "NAME": "China", "symbol": "CN / CHN", "code": "86"},
    {"id": "18", "NAME": "Bangladesh", "symbol": "BD / BGD", "code": "880"},
    {"id": "211", "NAME": "Taiwan", "symbol": "TW / TWN", "code": "886"},
    {"id": "220", "NAME": "Turkey", "symbol": "TR / TUR", "code": "90"},
    {"id": "95", "NAME": "India", "symbol": "IN / IND", "code": "91"},
    {"id": "160", "NAME": "Pakistan", "symbol": "PK / PAK", "code": "92"},
    {"id": "203", "NAME": "Sri Lanka", "symbol": "LK / LKA", "code": "94"},
    {"id": "144", "NAME": "Myanmar", "symbol": "MM / MMR", "code": "95"},
    {"id": "128", "NAME": "Maldives", "symbol": "MV / MDV", "code": "960"},
    {"id": "116", "NAME": "Lebanon", "symbol": "LB / LBN", "code": "961"},
    {"id": "107", "NAME": "Jordan", "symbol": "JO / JOR", "code": "962"},
    {"id": "210", "NAME": "Syria", "symbol": "SY / SYR", "code": "963"},
    {"id": "98", "NAME": "Iraq", "symbol": "IQ / IRQ", "code": "964"},
    {"id": "112", "NAME": "Kuwait", "symbol": "KW / KWT", "code": "965"},
    {"id": "188", "NAME": "Saudi Arabia", "symbol": "SA / SAU", "code": "966"},
    {"id": "238", "NAME": "Yemen", "symbol": "YE / YEM", "code": "967"},
    {"id": "159", "NAME": "Oman", "symbol": "OM / OMN", "code": "968"},
    {"id": "162", "NAME": "Palestine", "symbol": "PS / PSE", "code": "970"},
    {"id": "1", "NAME": "UAE", "symbol": "uae", "code": "971"},
    {"id": "227", "NAME": "United Arab Emirates", "symbol": "AE / ARE", "code": "971"},
    {"id": "101", "NAME": "Israel", "symbol": "IL / ISR", "code": "972"},
    {"id": "17", "NAME": "Bahrain", "symbol": "BH / BHR", "code": "973"},
    {"id": "172", "NAME": "Qatar", "symbol": "QA / QAT", "code": "974"},
    {"id": "25", "NAME": "Bhutan", "symbol": "BT / BTN", "code": "975"},
    {"id": "139", "NAME": "Mongolia", "symbol": "MN / MNG", "code": "976"},
    {"id": "147", "NAME": "Nepal", "symbol": "NP / NPL", "code": "977"},
    {"id": "97", "NAME": "Iran", "symbol": "IR / IRN", "code": "98"},
    {"id": "212", "NAME": "Tajikistan", "symbol": "TJ / TJK", "code": "992"},
    {"id": "221", "NAME": "Turkmenistan", "symbol": "TM / TKM", "code": "993"},
    {"id": "15", "NAME": "Azerbaijan", "symbol": "AZ / AZE", "code": "994"},
    {"id": "77", "NAME": "Georgia", "symbol": "GE / GEO", "code": "995"},
    {"id": "113", "NAME": "Kyrgyzstan", "symbol": "KG / KGZ", "code": "996"},
    {"id": "231", "NAME": "Uzbekistan", "symbol": "UZ / UZB", "code": "998"}
];


// WEBPACK FOOTER //
// ./src/redux/utils/countryCode.js